













































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Resolve } from 'vue-di';
import LayoutModule from '../store/layout';
import enrollment from '~/store/enrollment';
import EnrollmentModule from '~/store/enrollment';
import ArrowButton from '~/components/ArrowButton.vue';

@Component<PopUpModalComponentPHI>({
  components: {},
})
export default class PopUpModalComponentPHI extends Vue {
  @Resolve
  public enrollment!: EnrollmentModule;
  @Resolve
  public layout!: LayoutModule;

  isShowDialogue = true;
  public pathDecide = this.enrollment.currentDrugPath === 'Orgovyx';

  public dialogClosefunction(event: any) {
    this.$emit('closePopUpModal', event);
  }
}
